import * as React from "react";
import { ReactElement, useEffect, useRef, useState } from 'react';
import {
  Box,
  Stack,
  Heading,
  Text,
  Image,
  Button,
  useColorModeValue,
  Container,
  useToast,
  Flex,
  SimpleGrid,
  StackDivider,
  SpaceProps,
  HStack,
  Tag,
  Link,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  useDisclosure,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  FormControl,
  FormLabel,
  Input,
  Select,
  Center,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  FormErrorMessage,
  ButtonGroup,
  Grid,
  GridItem,
  Spacer,
  Skeleton
} from "@chakra-ui/react";
import { PageSlideFade } from "../components/page-transitions";
import { apiHost, baseUrl } from "utils/Cons/Constants";
import axios from "axios";
import { Helmet } from "react-helmet";
import { FaAccessibleIcon, FaBullseye, FaSearch, FaVolumeUp } from "react-icons/fa";
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L, { Icon, LatLng, LatLngExpression } from 'leaflet';
import markerIconPng from "../assets/images/marker-icon.png";
import { MotionBox } from "../components/motion";
import cloudsBg from "../assets/images/cloud-background.png";
import { Field, Formik } from "formik";
import Masonry from "react-masonry-css";
import "../style/style.css";
import useSound from "use-sound";
import parser from "html-react-parser";
import Slider from "react-slick";
import MediaBlock from "../components/media-block";
import FavoritesBlock from "../components/favorites-block";
import ImageBlock from "../components/image-block";
import CrowdBlock from "../components/crowd-block";
import MapBlock from "../components/map-block";
import CTABlock from "components/cta-block";
import ImagesBlock from "components/images-block";
import ImagesGridBlock from "components/images-grid-block";

interface PageData {
  fields: {
    content_blocks?: any[];
  };
  meta_title?: string;
  meta_description?: string;
  header_image_url?: string;
  title?: string;
  entry?: {
    content?: string;
  };
}

interface SearchValues {
  order?: string;
  title?: string;
  name?: string;
}

interface Variables {
  default_destination_img?: string;
  [key: string]: any;
}

interface Destination {
  title: string;
  main_img?: string;
  content?: string;
  items_list?: Array<{
    destination_name: string;
    content?: string;
  }>;
  slug?: string;
}

const markdownTheme = {
  p: props => {
    const { children } = props;
    return (
      <Text mb={2} fontSize={'0.8em'}>
        {children}
      </Text>
    );
  },
};

const Lists = (props) => {
  const toast = useToast();

  const [grid, setGrid] = useState(true);
  const [breakpointColumns, setBreakpointColumns] = useState({});

  const [searchValues, setSearchValues] = useState<SearchValues>({});

  const {
    isOpen: isModalOpen,
    onOpen: onModalOpen,
    onClose: onModalClose
  } = useDisclosure();

  const [destinations, setDestinations] = useState([]);
  const [loading, setLoading] = useState(true);

  const [featuredDestinations, setFeaturedDestinations] = useState([]);

  const [experiencesloading, setExperiencesLoading] = useState(false);
  const [experiences, setExperiences] = useState([]);

  const [activitiesloading, setActivitiesLoading] = useState(false);
  const [activities, setActivities] = useState([]);

  const [categoriesloading, setCategoriesLoading] = useState(false);
  const [categories, setCategories] = useState([]);

  const [selectedDestination, setSelectedDestination] = useState<Destination>({} as Destination);

  const [page, setPage] = useState<PageData>({ fields: {} });
  const [variables, setVariables] = useState<Variables>({});

  const bgColor = useColorModeValue('white', 'gray.900');
  const headingColor = useColorModeValue('gray.700', 'white');

  const position = [40.9133945, -77.7782867];

  /*
  const [play] = useSound(sound, {
    volume: 1
  });
  */

  // drawers
  const { isOpen, onOpen, onClose } = useDisclosure()
  const firstField = useRef()

  const {
    isOpen: isFilterOpen,
    onOpen: onFilterOpen,
    onClose: onFilterClose
  } = useDisclosure()

  const initialMarkers = [];
  const [markers, setMarkers] = useState(initialMarkers);

  const breakpointColumnsObj = {
    default: 3,
    1200: 2,
    400: 1
  };

  const breakpointColumnsListObj = {
    default: 1
  };

  const settingsSlickEvents = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    adaptiveHeight: false,
    autoplay: true,
    autoplaySpeed: 8000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  const LocationMarkers = () => {
    return (
      <React.Fragment>
        {markers.map(marker => <Marker
          position={marker.location}
          icon={new Icon({ iconUrl: markerIconPng, iconSize: [25, 41], iconAnchor: [12, 41] })}
          eventHandlers={{
            click: (e) => {
              setSelectedDestination(marker.data);
              onOpen();
            },
          }}>
        </Marker>)}
      </React.Fragment>
    );
  }

  const getTips = (values = null) => {
    let data = [];
    setLoading(true);
    axios.post(`${apiHost}/itineraries/list`, values)
      .then(res => {
        data = res.data;
        console.log(data);
        if (res.status == 200) {
          setLoading(false);
          setDestinations(data);
          setFeaturedDestinations(data.slice(0, 10));

          let geomarkers = [];
          data.forEach(marker => {
            if (marker.destination) {
              geomarkers.push({ data: marker, location: new LatLng(marker.destination.location_latitude, marker.destination.location_longitude) })
            }
          });
          setMarkers(geomarkers);
        }
        return res;
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
        setDestinations([]);
        setFeaturedDestinations([]);
      });

    return data;
  };

  const getPage = () => {
    axios.get(`${apiHost}/page/get/itineraries`)
      .then(res => {
        if (res.status == 200) {
          setPage(res.data as PageData);
        }
        return res;
      })
      .catch(err => console.log(err));
  };

  const getVariables = () => {
    let data = {} as Variables;
    axios.get(`${apiHost}/variables/get/global`)
      .then(res => {
        data = res.data as Variables;
        if (res.status == 200) {
          console.log(data);
          setVariables(data as Variables);
        }
        return res;
      })
      .catch(err => console.log(err));

    return data;
  };

  const showToast = (message, status) => {
    toast({
      position: "bottom",
      description: message,
      status: status,
      duration: 5000,
      isClosable: true
    });
  };

  const showNotification = (message, status) => {
    toast({
      position: "bottom",
      description: message,
      status: status,
      duration: 10000,
      isClosable: true
    });
  };

  const handleReset = () => {
    
  };

  const handleDestinationClick = (destination) => {
    setSelectedDestination(destination);
    onOpen();
  }

  function validateEmail(value) {
    let error;
    if (!value) {
      error = "Email is required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      error = "Invalid email address";
    }
    return error;
  }

  const sortClick = function (order: string) {
    setSearchValues({...searchValues, order});
    getTips({...searchValues, order});
  }

  const onGridList = function (breakpointColumns) {
    setBreakpointColumns(breakpointColumns)
    if (breakpointColumns.default == 1) {
      setGrid(false);
    } else {
      setGrid(true);
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    getPage();
    getTips();
    getVariables();
    setBreakpointColumns(breakpointColumnsObj);
    //showNotification("Search for destinations notification", "info");
    /*
    setTimeout(() => {
      onModalOpen();
    }, 2000);
    */
  }, []);

  return (
    <PageSlideFade>
      <Helmet>
        <title>{page.meta_title}</title>
        <meta name="description" content={page.meta_description} />
      </Helmet>
      <Box className="home-header-container" backgroundImage={`url(${page.header_image_url})`} backgroundPosition="center center" backgroundSize="cover" minHeight="60vh">
        <Container maxW={'6xl'}>
          <Box display="flex" flexDirection="column" flex="1" minHeight="60vh">
            <Box mt={'auto'}>
              <Heading
                as={'h1'}
                fontFamily="american"
                fontWeight={600}
                fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
                color="white"
                lineHeight={'100%'}
                textAlign="left"
                textShadow="0px 0px 5px #000"
              >
                {page.title} {' '}
              </Heading>
            </Box>
          </Box>
        </Container>
      </Box>
      <Box>
        <Container maxW={'6xl'}>
          <Box className="content-block" pt={10} pb={10}>
            {page.entry ? (
              <Text textAlign="left">
                {parser(page.entry.content)}
              </Text>
            ) : null}
          </Box>
        </Container>
      </Box>
      {page.fields.content_blocks?.map((block, index) => (
        <Box key={`block-${index}`}>
          {
            {
              'anomaly.extension.favorites_block_block': <FavoritesBlock page={page} block={block} />,
              'anomaly.extension.media_block_block': <MediaBlock page={page} block={block} />,
              'anomaly.extension.image_block_block': <ImageBlock page={page} block={block} />,
              'anomaly.extension.crowd_block_block': <CrowdBlock page={page} block={block} />,
              'anomaly.extension.map_block_block': <MapBlock page={page} block={block} />,
              'anomaly.extension.cta_block_block': <CTABlock page={page} block={block} />,
              'anomaly.extension.images_block_block': <ImagesBlock page={page} block={block} />,
              'anomaly.extension.images_grid_block_block': <ImagesGridBlock page={page} block={block} />,
            }[block.extension]
          }
        </Box>
      ))}
      <Box bg="white" display="none">
        <Box>
          <div className="events-header">
            <Heading
              as={'h2'}
              fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
              lineHeight={'110%'}
              pt={10}>
              {page.title}
            </Heading>
          </div>

          <Box p={20}>
            <Slider {...settingsSlickEvents} className="events-slider">

              {featuredDestinations?.map((destination, index) => (
                <div>
                  <Box bg="#E6DFD3" borderRadius={10} m={3}>
                    <Link href={`/itineraries/${destination.slug}`}>
                      <Image src={destination.main_img || variables.default_destination_img} borderTopRadius={10} />
                      <Box p={5}>
                        <Heading fontSize="1.45rem" textAlign="left">{destination.title}</Heading>
                      </Box>
                    </Link>
                  </Box>
                </div>
              ))}

            </Slider>
          </Box>

        </Box>

      </Box>
      <Box bg="white" pt={10}>
        <Box>
          <SimpleGrid columns={3}>
            <Box textAlign="left">
              <Button onClick={() => onFilterOpen()} p={5} borderLeftRadius={0}>Filter</Button>
            </Box>
            <Box display={{ base: "none", md: "block" }}>
              <ButtonGroup spacing='2'>
                <Button 
                  onClick={() => onGridList(breakpointColumnsObj)} 
                  p={5}
                  borderTopEndRadius={0}
                  borderBottomEndRadius={0}
                  bg={grid ? "#D51F0C" : "gray.200"}
                  color={grid ? "white" : "black"}
                  _hover={{
                    bg: grid ? "#143b49" : "gray.300"
                  }}
                >
                  Grid
                </Button>
                <Button 
                  onClick={() => onGridList(breakpointColumnsListObj)} 
                  p={5}
                  borderTopStartRadius={0}
                  borderBottomStartRadius={0}
                  bg={!grid ? "#D51F0C" : "gray.200"}
                  color={!grid ? "white" : "black"}
                  _hover={{
                    bg: !grid ? "#143b49" : "gray.300"
                  }}
                >
                  List
                </Button>
              </ButtonGroup>
            </Box>
            <Box display="flex" flexDirection="row" alignItems="right" >
              <HStack marginLeft="auto" mb={5} mr={5}>
                <Spacer />
                <Text w="100px" textAlign="right">Sort By</Text>
                <Select
                  onChange={(e) => {
                    sortClick(e.target.value);
                  }} w={{ base: "120px", md: "200px" }}>
                  <option value="upcoming" selected>Last Updated</option>
                  <option value="title">Title</option>
                </Select>
              </HStack>
            </Box>
          </SimpleGrid>
        </Box>
        <SimpleGrid columns={{ base: 1, 'xxl': 2 }} spacing={10} mt={8}>
          <Box p={5}>
            {loading && (
              <Box p={5}>
                <Skeleton height="80px" />
                <Text mt="-50px" mb="50px" fontWeight="bold" textAlign="center">
                  Loading Bellefonte Itineraries ...
                </Text>
              </Box>
            )}
            {!loading && (
              <Masonry breakpointCols={breakpointColumns}
                className="masonry-grid"
                columnClassName="masonry-grid_column">

                {destinations?.map((destination, index) => (
                  <Box
                    key={`${destination.id}-${destination.slug}-${index}`}
                    w={'100%'}
                    bg="#FBEEC8"
                    boxShadow={'0 0 10px 2px #ccc'}
                    rounded={'md'}
                    _hover={{
                      bg: '#E0CEBE'
                    }}
                    d="inline-block"
                    mb={5}
                    className="masonry"
                  >
                    <Box
                    >
                      {(destination.main_img || variables.default_destination_img) && (
                        <Link onClick={() => handleDestinationClick(destination)}>
                          <Image
                            src={`${destination.main_img || variables.default_destination_img}`}
                            w={'100%'}
                            rounded={'md'}
                            borderBottomRadius={"0"}
                          />
                        </Link>
                      )}
                      <Box position="relative" p={2}>
                        <Link onClick={() => handleDestinationClick(destination)}>
                          <Heading
                            color={headingColor}
                            fontSize={'lg'}
                            fontFamily={'roboto'}
                            fontWeight={600}
                            pt={2}
                            lineHeight="115%"
                            pb={2}>
                            {destination.title}
                          </Heading>
                        </Link>
                      </Box>
                    </Box>
                  </Box>
                ))
                }
              </Masonry>
            )}

          </Box>
          <Box>
            <Box sx={{ position: ['sticky', '-webkit-sticky'], top: '0px', }}>
                              <MapContainer center={position as LatLngExpression} zoom={10} scrollWheelZoom={false} style={{ minHeight: L.Browser.mobile ? '50vh' : '100vh' }} tap={!L.Browser.mobile} dragging={!L.Browser.mobile}>
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <LocationMarkers />
              </MapContainer>
            </Box>
          </Box>
        </SimpleGrid>
      </Box>

      <Drawer
        isOpen={isOpen}
        size="lg"
        placement="left"
        closeOnOverlayClick={true}
        onClose={onClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth="1px">
            <Heading pb={0}>{selectedDestination.title}</Heading>
          </DrawerHeader>

          <DrawerBody>
            <Stack spacing="14px">
              <Center>
                {selectedDestination.main_img && (
                  <Image
                    src={`${selectedDestination.main_img}`}
                    width={'100%'}
                    borderRadius="md"
                    alt={selectedDestination.title}
                  />
                )}
              </Center>

              {selectedDestination.content ? (
                <Box className="content-block">{parser(selectedDestination.content)}</Box>
              ) : null}

              {selectedDestination.items_list?.map((item, index) => (
                <Box>
                  <h3>#{index + 1} - {item.destination_name}</h3>
                  {item.content ? (
                    <Center><Box className="content-block">{parser(item.content)}</Box></Center>
                  ) : null}
                </Box>
              ))}

            </Stack>

          </DrawerBody>

          <DrawerFooter borderTopWidth="1px" justifyContent="flex-end">
            <Button mr={3} onClick={onClose}>
              Close
            </Button>
            {selectedDestination ? (
              <Button as={Link} href={`/itineraries/${selectedDestination.slug}`} >More Information</Button>
            ) : null}
          </DrawerFooter>
        </DrawerContent>
      </Drawer>

      <Drawer
        isOpen={isFilterOpen}
        size="md"
        placement="left"
        closeOnOverlayClick={true}
        onClose={onFilterClose}
      >
        <DrawerOverlay />

        <Formik
          enableReinitialize
          initialValues={{ title: "", name: "" }}
          onReset={(values, actions) => {
            getTips();
            handleReset();
            onFilterClose();
          }}
          onSubmit={(values, actions) => {
            setSearchValues(values);
            getTips(values);
            onFilterClose();
            actions.setSubmitting(false);
          }}
        >
          {({ values, handleChange, handleSubmit, handleReset, isSubmitting, setFieldValue }) => {
            return (
              <form id="searchForm" autoComplete="off" onSubmit={handleSubmit} onReset={handleReset} onChange={handleChange} style={{ width: "100%" }}>
                <DrawerContent>

                  <DrawerCloseButton />
                  <DrawerHeader borderBottomWidth="1px">
                    <Heading pb={0}>Filter</Heading>
                  </DrawerHeader>

                  <DrawerBody>

                    <Field
                      name="title"
                      width={"100%"}
                    >
                      {({ field, form }) => (
                        <FormControl>
                          <FormLabel mt={2}>Itinerary</FormLabel>
                          <Input
                            {...field}
                            id="title"
                            borderRadius="15px"
                            fontSize="sm"
                            type="text"
                            placeholder='Local'
                            size="lg"
                            value={values.title}
                            onChange={handleChange}
                          />
                        </FormControl>
                      )}
                    </Field>

                    <Field
                      name="name"
                      width={"100%"}
                    >
                      {({ field, form }) => (
                        <FormControl>
                          <FormLabel mt={2}>Destination Name</FormLabel>
                          <Input
                            {...field}
                            id="name"
                            borderRadius="15px"
                            fontSize="sm"
                            type="text"
                            placeholder='Penn State'
                            size="lg"
                            value={values.name}
                            onChange={handleChange}
                          />
                        </FormControl>
                      )}
                    </Field>

                  </DrawerBody>

                  <DrawerFooter borderTopWidth="1px" justifyContent="flex-end">
                    <Button mr={3} onClick={onFilterClose}>
                      Close
                    </Button>
                    <Button mr={3} type="reset">Reset</Button>
                    <Button mr={3} type="submit" isLoading={isSubmitting}>Search</Button>
                  </DrawerFooter>
                </DrawerContent>
              </form>
            );
          }}
        </Formik>
      </Drawer>

    </PageSlideFade>
  );
};

export default Lists;
